
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Dialog, Toast } from "vant";
import { rankClickTabs, modelList } from "./configData";
import { onshelf, downshelf, takeBack } from "@/req/user";
@Component
export default class Particulars extends Vue {
  public clickTabs: any = [];
  public list = modelList;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public obj;
  @Watch("obj")
  public isChange(val) {
    if (val.status != undefined && val.status != null) {
      this.clickTabs = rankClickTabs;
    }
  }
  public submit(item) {
    if (item.id === 0) {
      this.getDialgo(this.list[0]);
    } else if (item.id === 5 && this.obj.status === 1) {
      this.getDialgo(this.list[1]);
    } else if (item.id === 5 && this.obj.status === 2) {
      this.getDialgo(this.list[4]);
    } else if (item.id === 2 && this.obj.status === 1) {
      this.getDialgo(this.list[2]);
    } else if (item.id === 4) {
      this.getDialgo(this.list[3]);
    } else if (item.id === 2) {
        this.$emit("showPopup", this.obj)
    }
  }
  public getDialgo(val) {
    Dialog.confirm({
      message: val.title,
      confirmButtonText: val.btn,
      confirmButtonColor: "#323233",
    })
      .then(() => {
        if (val.changeStatus === 1) {
          this.getDownshelf();
        } else if (val.changeStatus === 2) {
          this.getOnshelf();
        } else if (val.changeStatus === 3) {
          this.getTakeBack();
        }
      })
      .catch(() => {
        // on cancel
      });
  }
  public async getDownshelf() {
    const res = await downshelf({
      commodity_id: this.obj.id,
    });
    if (res.code === 200) {
      Toast.success(res.msg);
      this.$emit("detailList");
    } else {
      Toast.fail(res.msg);
    }
  }
  public async getOnshelf() {
    const res = await onshelf({
      commodity_id: this.obj.id,
    });
    if (res.code === 200) {
      Toast.success(res.msg);
      this.$emit("detailList");
    } else {
      Toast.fail(res.msg);
    }
  }
  public async getTakeBack() {
    const res = await takeBack({
      commodity_id: this.obj.id,
    });
    if (res.code === 200) {
      Toast.success(res.msg);
      this.$emit("detailList");
    } else {
      Toast.fail(res.msg);
    }
  }
}
